import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Single (non-prod) environment and the webpack browser builder does not define `ngDevMode`,
// so production mode is enabled explicitly for every build.
enableProdMode();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
